var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyMind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_20766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54004 3.11475C1.84907 3.95206 2.43652 4.58581 3.03619 5.03451",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1787 2.92978L12.9227 4.48259C13.8619 5.32705 14.5319 6.42342 14.8034 7.6528H15.2419C15.9145 7.6528 16.4598 8.20412 16.4598 8.88419V11.8173C16.4598 12.2838 16.1991 12.7102 15.7865 12.9187L13.8651 13.8902C14.0859 15.0264 13.3757 16.1429 12.2513 16.4044C11.1382 16.6634 10.0282 15.9895 9.72212 14.8897C9.24497 14.9888 8.74852 15.0411 8.23877 15.0411C7.53018 15.0411 6.84729 14.94 6.20625 14.7526L6.1983 14.7876C5.93435 15.9474 4.79044 16.6713 3.64328 16.4044C2.49613 16.1375 1.78015 14.981 2.04409 13.8212L2.3627 12.4211C2.3929 12.2885 2.4346 12.1615 2.4865 12.0411C1.88556 11.118 1.54016 10.0382 1.54016 8.88419C1.54016 5.48379 4.53924 2.72722 8.23877 2.72722C8.65839 2.72722 9.06899 2.76268 9.46724 2.83052C10.1279 1.9568 11.1073 1.65227 11.9795 1.54772C12.7268 1.45814 13.3023 2.1792 13.1787 2.92978Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2295 5.61096H6.41675",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2823 7.86975V8.99998",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_20766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyMind);
export default __webpack_public_path__ + "static/media/money_mind.e7e587b55ce28b4d50f46fd24a5bf7c7.svg";
export { ForwardRef as ReactComponent };